import { render, staticRenderFns } from "./ContactViewItem.vue?vue&type=template&id=7770dbb2&scoped=true&"
import script from "./ContactViewItem.vue?vue&type=script&lang=js&"
export * from "./ContactViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770dbb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VIcon,VRating})
